export const getters = {
  systemDailytransactions: state => state.dailytransactions,
  Dailytransaction: state => state.dailytransaction,
  
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/dailytransactions/getters.js